import React, { Component } from 'react';
import {inject, observer} from 'mobx-react';
import SubscriptionPlan from './components/SubscriptionPlan';
import {DropDown, InputField} from '../InputForms';
import {TextButton, TextButtonTypes} from '../Buttons';
import DialogModal from '../DialogModal';
import styles from './style.css';
import sortBy from 'lodash/sortBy';

class AddAgentModal extends Component {
    render() {
        return <EditAgentModal {...this.props}/>
    }
}

@inject('store', 'localizationStore')
@observer
export class EditAgentModal extends Component {
    constructor (props) {
        super(props)
        this.state = EditAgentModal.getInitState(props.agent)
    }

    static getInitState(agent) {
        if (!agent) {
            return {
                agentsUserId: localStorage.getItem('userId'),
                description: '',
                greetingMessage: '',
                status: 'BEING_TESTED',
                agentSubscriptionPlans: defaultSubscriptionPlans,
                color: '122, 122, 122'
            }
        } else {
            const {id, description, greetingMessage, status, agentSubscriptionPlans, colour} = agent
            const sortedPlans = sortBy(agentSubscriptionPlans.slice(), [
                plan => ['DAY', 'WEEK', 'MONTH', 'YEAR'].findIndex(x => x === plan.subscriptionInterval),
                plan => ['USER', 'ORGANIZATION'].findIndex(x => x === plan.agentSubscriptionPlanOwnerType),
            ])
            const color = displayColorValues(colour)
            return {id, description, greetingMessage, status, agentSubscriptionPlans: sortedPlans, color}
        }
    }

    onInputChange = (event) => {
        switch(event.target.name){
            case 'greetingMessage': {
                this.setState({greetingMessage: event.target.value})
                break
            }
            case 'description': {
                this.setState({description: event.target.value})
                break
            }
            case 'status': {
                this.setState({status: event.target.value})
                break
            }
            case 'user_id': {
                this.setState({agentsUserId: event.target.value})
                break
            }
            case 'color': {
                this.setState({color: event.target.value})
                break
            }
            default:
                break
        }
    }

    onSubscriptionChange = (index) => (state) => {
        const newSub = this.state.agentSubscriptionPlans.slice()
        newSub[index] = state
        this.setState({subscriptions: newSub})
    }

    onCreateAgent = () => {
        const {agentsUserId, description, greetingMessage, status, agentSubscriptionPlans} = this.state
        const agentData = {
          agentsUserId,
          description: description.trim(),
          greetingMessage,
          status: status,
          agentSubscriptionPlans
        }
        this.props.store.createAgentRequest(agentData).then(this.props.onSuccess)
    }

    onSaveEditAgent = () => {
        const {description, status, greetingMessage, agentSubscriptionPlans, color} = this.state
        const agentData = {
          description,
          status,
          greetingMessage,
          agentSubscriptionPlans,
          colour: parseColor(color)
        }
        this.props.agent.setProperties(agentData).then(this.props.onSuccess)
    }


    validData = () => {
        const validColor = !!parseColor(this.state.color)
        return (this.state.description.trim() !== '') && validColor
    }

    render() {
        const locale = this.props.localizationStore.locale
        const statusValues = [
            {value: 'ACTIVE', label: locale.active, disabled: true},
            {value: 'BEING_TESTED', label: locale.being_tested},
            {value: 'INACTIVE', label: locale.inactive}
        ]
        const subscriptions = this.state.agentSubscriptionPlans.map((subscription, i) => <SubscriptionPlan key={i} onChange={this.onSubscriptionChange(i)} subscription={subscription}/>)
        const button = this.props.agent ? <TextButton text={locale.apply} type={TextButtonTypes.primary} onClick={this.onSaveEditAgent} disabled={!this.validData()}/>
         : <TextButton text={locale.create} type={TextButtonTypes.primary} onClick={this.onCreateAgent} disabled={!this.validData()}/>
        const userIdField = !this.props.agent ? <InputField style={styles.inputForm}
                                                            type='number'
                                                            required
                                                            value={this.state.agentsUserId}
                                                            name='user_id'
                                                            placeholder={locale.user_id}
                                                            onChange={this.onInputChange}
                                                            label={locale.id}
                                                            disabled={!this.props.store.isAdministrator()}/> : null
        const warning = !this.props.agent && !this.props.store.isRegularOrTestUser() && !this.props.store.isAdministrator()
            ? <div>{locale.warning_role_will_change.replace('{{role}}', this.props.store.currentUserRole.replace(/_/g, ' '))}<br/>
                {locale.warning_consider_creating_a_new_account}<br/><br/></div> : null

        return (
            <DialogModal onClose={this.props.onClose}
                         button={button}
            >
                <div className={styles.modal}>
                    {userIdField}
                    {warning}
                    <InputField style={styles.inputForm}
                                type='textarea'
                                required
                                value={this.state.description}
                                name='description'
                                placeholder={locale.description}
                                onChange={this.onInputChange}
                    />
                    <InputField style={styles.inputForm}
                                type='textarea'
                                required
                                value={this.state.greetingMessage}
                                name='greetingMessage'
                                placeholder={locale.greetingMessage}
                                label={locale.greetingMessage}
                                onChange={this.onInputChange}
                    />
                    <DropDown style={styles.inputForm}
                              required
                              name='status'
                              options={statusValues}
                              value={this.state.status}
                              onChange={this.onInputChange}
                              label={locale.status}
                              viewedByAdministrator={this.props.store.isAdministrator()}
                    />
                    <InputField
                      style={styles.inputForm}
                      type={'text'}
                      label={'Color'}
                      value={this.state.color}
                      name={'color'}
                      placeholder={'red, green, blue[, alpha=100%]'}
                      valid={parseColor(this.state.color)}
                      onChange={this.onInputChange}/>
                    <div style={{backgroundColor: getCSSColor(this.state.color) || 'white', height: 15, width: 15}}/>
                    <div className={styles.subscription}>
                        {subscriptions}
                    </div>
                </div>
            </DialogModal>
        );
    }
}

function displayColorValues(colour) {
  if (!colour) {
    return ''
  }
  const {red, green, blue, alpha} = colour
  return `${red}, ${green}, ${blue}${alpha ? `, ${alpha*100}%` : ''}`
}


function parseColor(string) {
  const test = /^(\d{1,2}|1\d\d|2(?:[0-4]\d|5[0-5])), (\d{1,2}|1\d\d|2(?:[0-4]\d|5[0-5])), (\d{1,2}|1\d\d|2(?:[0-4]\d|5[0-5]))(?:, ((?:\d{1,2}|100))%)?$/
  const match = string.match(test)
  if (match) {
    let [,red, green, blue, alpha] = match
    if (alpha) {
      alpha /= 100
    } else {
      alpha = 1
    }
    return {red, green, blue, alpha}
  }
  return null
}

function getCSSColor(color) {
  const values = parseColor(color)
  if (values) {
    const {red, green, blue, alpha} = values
    if (alpha) {
      return `rgba(${red}, ${green}, ${blue}, ${alpha})`
    } else {
      return `rgb(${red}, ${green}, ${blue})`
    }
  }
  return null
}

const defaultSubscriptionPlans = [
    {
      "subscriptionInterval": "DAY",
      "subscriptionIntervalCount": 1,
      "capacity": 15,
      "agentSubscriptionPlanPricings": [
        {
          "currency": "EUR",
          "salary": 5,
          "id": 41
        }
      ],
      "id": 41,
      "agentSubscriptionPlanOwnerType": "USER"
    },
    {
      "subscriptionInterval": "WEEK",
      "subscriptionIntervalCount": 1,
      "capacity": 15,
      "agentSubscriptionPlanPricings": [
        {
          "currency": "EUR",
          "salary": 5,
          "id": 42
        }
      ],
      "id": 42,
      "agentSubscriptionPlanOwnerType": "USER"
    },
    {
      "subscriptionInterval": "MONTH",
      "subscriptionIntervalCount": 1,
      "capacity": 15,
      "agentSubscriptionPlanPricings": [
        {
          "currency": "EUR",
          "salary": 5,
          "id": 43
        }
      ],
      "id": 43,
      "agentSubscriptionPlanOwnerType": "USER"
    },
    {
      "subscriptionInterval": "MONTH",
      "subscriptionIntervalCount": 1,
      "capacity": 15,
      "agentSubscriptionPlanPricings": [
        {
          "currency": "EUR",
          "salary": 5,
          "id": 44
        }
      ],
      "id": 44,
      "agentSubscriptionPlanOwnerType": "ORGANIZATION"
    },
    {
      "subscriptionInterval": "YEAR",
      "subscriptionIntervalCount": 1,
      "capacity": 15,
      "agentSubscriptionPlanPricings": [
        {
          "currency": "EUR",
          "salary": 5,
          "id": 45
        }
      ],
      "id": 45,
      "agentSubscriptionPlanOwnerType": "ORGANIZATION"
    }
  ]


export default AddAgentModal;


// WEBPACK FOOTER //
// ./src/components/AddAgentModal/index.js